export const contenthistoryConstants = {
    GETALL_REQUEST: 'CONTENTHISTORY_GETALL_REQUEST',
    GETALL_SUCCESS: 'CONTENTHISTORY_GETALL_SUCCESS',
    GETALL_FAILURE: 'CONTENTHISTORY_GETALL_FAILURE',

    UPDATE_REQUEST: 'CONTENTHISTORY_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'CONTENTHISTORY_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'CONTENTHISTORY_UPDATE_FAILURE',

    DELETE_REQUEST: 'CONTENTHISTORY_DELETE_REQUEST',
    DELETE_SUCCESS: 'CONTENTHISTORY_DELETE_SUCCESS',
    DELETE_FAILURE: 'CONTENTHISTORY_DELETE_FAILURE'
};
